import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, Route } from '@angular/router';
import { SubscriptionsearchClass } from '../Classes/SubscriptionsearchClass';
import { SubscriptionService } from '../Services/SubscriptionService';
import { CommonSearch } from '../Classes/CommonClass';
import { IMyDpOptions } from 'mydatepicker';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'Subscriptionsearch',
  templateUrl: '../Subscription/Subscriptionsearch.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/fixedheader.css'],
  providers: [SubscriptionService]
})

export class SubscriptionSearch implements OnInit {
  _Subscription = new SubscriptionsearchClass();
  _CommonSearch = new CommonSearch();
  innerWidth: number;
  tableRowWidth: number = 99;
  loading: boolean = false;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  GetSubscriptionDetails: any = [];
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '18px',
    width: '200px',
    selectionTxtFontSize: '12px',
    inline: false,
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };
  SearchdropFirst: any[] = [
    { Value: 'Module', Text: 'Module' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'BillingStartDate', Text: 'Billing Start Date' },
    { Value: 'TerminationDate', Text: 'Termination Date' }
  ]
  SearchdropSecond: any[] = [
    { Value: 'Module', Text: 'Module' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'BillingStartDate', Text: 'Billing Start Date' },
    { Value: 'TerminationDate', Text: 'Termination Date' }
  ]

  constructor(
    public SubscriptionService: SubscriptionService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    public _router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }
  ngOnInit() {
    this.ChangeHeadeFooterColor();
    this._Subscription.SearchdropFirst = "-1";
    this._Subscription.SearchdropSecond = "-1";
    this._Subscription.SearchMatchesFirst = "Contains";
    this._Subscription.SearchMatchesSecond = "Contains";

    let _SearchParm = localStorage.getItem('SearchParm');
    if (_SearchParm != null) {
      let Parm = JSON.parse(_SearchParm);
      this._Subscription.SearchdropFirst = Parm[0].Text;
      this._Subscription.SearchMatchesFirst = Parm[1].Text;
      this._Subscription.SearchtextFirst = Parm[2].Text;
      this._Subscription.SearchdropSecond = Parm[3].Text;
      this._Subscription.SearchMatchesSecond = Parm[4].Text;
      this._Subscription.SearchtextSecond = Parm[5].Text;
      this.BtnSearch();
    }
  }

  public FilterFirstChange(Searchdrop: string) {
    this.SearchdropSecond = [];
    let SearchdropFirstdata: any[] = this._Subscription.SearchdropSecondList;
    for (let i = 0; i < SearchdropFirstdata.length; i++) {
      if (SearchdropFirstdata[i].Value != Searchdrop) {
        this.SearchdropSecond.push(SearchdropFirstdata[i]);
      }
      else {
        this.SearchdropFirst.slice(i, 1);
      }
    }
    this._Subscription.SearchtextFirst = "";
    if (this._Subscription.SearchdropFirst == "Status") {
      this._Subscription.SearchtextFirst = "Active";
      this._Subscription.SearchMatchesFirst = "Exact";
    }
    else { this._Subscription.SearchMatchesFirst = "Contains"; }

    if (this._Subscription.SearchdropFirst == "BillingStartDate" || this._Subscription.SearchdropFirst == "TerminationDate") {
      this._Subscription.SearchMatchesFirst = "Exact";
    }
    else {
      //this._Subscription.SearchMatchesFirst = "Contains";
    }
  }

  public FilterSecondChange(Searchdrop: string) {
    this.SearchdropFirst = [];
    let SearchdropSeconddata: any[] = this._Subscription.SearchdropFirstList;
    for (let i = 0; i < SearchdropSeconddata.length; i++) {
      if (SearchdropSeconddata[i].Value != Searchdrop) {
        this.SearchdropFirst.push(SearchdropSeconddata[i]);
      }
      else {
        this.SearchdropSecond.slice(i, 1);
      }
    }
    this._Subscription.SearchtextSecond = "";
    if (this._Subscription.SearchdropSecond == "Status") {
      this._Subscription.SearchtextSecond = "Active";
      this._Subscription.SearchMatchesSecond = "Exact";
    }
    else { this._Subscription.SearchMatchesSecond = "Contains"; }

    if (this._Subscription.SearchdropSecond == "BillingStartDate" || this._Subscription.SearchdropSecond == "TerminationDate") {
      this._Subscription.SearchMatchesSecond = "Exact";
    }
    else {
      // this._Subscription.SearchMatchesSecond = "Contains";
    }
  }

  public GetSubscriptionSearchAutocomplete = (SearchType: any, Searchstring: any): Observable<any[]> => {
    
    if (SearchType) {
      this._CommonSearch.SearchType = SearchType;
      this._CommonSearch.Searchstring = Searchstring;
      let Result = this.SubscriptionService.GetSubscriptionAutoCompleteResult(this._CommonSearch)
      return Result;
    }
    else {
      return Observable.of([]);
    }
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }


  public BtnSearch() {
    this.loading = true;
    var mQuery: string = "";
    if ((this._Subscription.SearchdropFirst != "-1") || (this._Subscription.SearchdropSecond != "-1")) {
      
      if (!this._Subscription.SearchtextFirst.jsdate) {
        this._Subscription.SearchtextFirst = this._Subscription.SearchtextFirst;
      }
      else {
        this._Subscription.SearchtextFirst = formatDate(this._Subscription.SearchtextFirst.jsdate);
      }
      let pattern = new RegExp(/^[- a-z. 0-9 _ < > & $ % @ * ~ ! ^ + = : ; , | ( ) { } \/ ! # ]+$/i)
      /***********************First Drop Down ****************************************/
      if (this._Subscription.SearchdropFirst != "-1") {

        if (this._Subscription.SearchtextFirst != undefined && this._Subscription.SearchtextFirst != "") {
          if (this._Subscription.SearchMatchesFirst == "Contains") {
            mQuery = "where " + this._Subscription.SearchdropFirst + ' like ' + "'%" + this._Subscription.SearchtextFirst + "%'";
          }
          else if (this._Subscription.SearchMatchesFirst == "Exact") {
            mQuery += "where " + this._Subscription.SearchdropFirst + ' = ' + "'" + this._Subscription.SearchtextFirst + "'";
          }
        }

        else {
          this.toastr.error('Please enter the ' + this._Subscription.SearchdropFirst + '.');
          this.loading = false;
          return;
        }
      }

      if (!this._Subscription.SearchtextSecond.jsdate) {
        this._Subscription.SearchtextSecond = this._Subscription.SearchtextSecond;
      }
      else {
        this._Subscription.SearchtextSecond = formatDate(this._Subscription.SearchtextSecond.jsdate);
      }
      /***********************Second Drop Down ****************************************/
      if (this._Subscription.SearchdropSecond != "-1") {

        if (this._Subscription.SearchtextSecond != undefined && this._Subscription.SearchtextSecond != "") {
          if (!this._Subscription.SearchtextFirst) {
            if (this._Subscription.SearchMatchesSecond == "Contains") {
              mQuery += "where " + this._Subscription.SearchdropSecond + ' like ' + "'%" + this._Subscription.SearchtextSecond + "%'";
            }
            else if (this._Subscription.SearchMatchesSecond == "Exact") {
              mQuery += "where " + this._Subscription.SearchdropSecond + ' = ' + "'" + this._Subscription.SearchtextSecond + "'";
            }

          }
          else {
            if (this._Subscription.SearchdropSecond != "State") {
              if (this._Subscription.SearchMatchesSecond == "Contains") {
                mQuery += "and " + this._Subscription.SearchdropSecond + ' like ' + "'%" + this._Subscription.SearchtextSecond + "%'";
              }
              else if (this._Subscription.SearchMatchesSecond == "Exact") {
                mQuery += "and " + this._Subscription.SearchdropSecond + ' = ' + "'" + this._Subscription.SearchtextSecond + "'";
              }
            }
          }
        }

        else {
          this.toastr.error('Please enter the ' + this._Subscription.SearchdropSecond + '.');
          this.loading = false;
          return;
        }
      }
    }
    else {
      this.toastr.error('Please select at least one criteria.');
      this.loading = false;
      return;
    }
    var dateformat = "/^\d{1,2}\/\d{1,2}\/\d{4}$/";

    if (!this._Subscription.SearchtextFirst.toString().match(dateformat)) {
      this._Subscription.SearchtextFirst = this._Subscription.SearchtextFirst;
    }
    else {
      this._Subscription.SearchtextFirst = { jsdate: new Date(this._Subscription.SearchtextFirst) };
    }
    if (!this._Subscription.SearchtextSecond.toString().match(dateformat)) {
      this._Subscription.SearchtextSecond = this._Subscription.SearchtextSecond;
    }
    else {
      this._Subscription.SearchtextSecond = { jsdate: new Date(this._Subscription.SearchtextSecond) };
    }
    let SearchString = [
      { Value: 'First', Text: this._Subscription.SearchdropFirst },
      { Value: 'Second', Text: this._Subscription.SearchMatchesFirst },
      { Value: 'Third', Text: this._Subscription.SearchtextFirst },
      { Value: 'Fourth', Text: this._Subscription.SearchdropSecond },
      { Value: 'FiFth', Text: this._Subscription.SearchMatchesSecond },
      { Value: 'Sixth', Text: this._Subscription.SearchtextSecond }
    ]

    localStorage.setItem('SearchParm', JSON.stringify(SearchString));
    this._CommonSearch.SearchQuery = mQuery;
    this.SubscriptionService.GetSubscriptionSearchResult(this._CommonSearch).subscribe(res => {
      var data = res;
      if (data.length > 15) {
        this.tableRowWidth = 100;
      }
      else {
        this.tableRowWidth = 99;
      }
      if (!data.Message) {
        this.GetSubscriptionDetails = data;
        this.loading = false;
      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }

  public EditOrganizationPage(TenantID: string) {
    this._router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(TenantID)), pageName: btoa(JSON.stringify('Subscription')) }]);
  }

  public EditEntityPage(TenantID: string, OrgCode: string, EntityID: string) {
    this._router.navigate(['/CreateEntity', { TenantID: btoa(JSON.stringify(TenantID)), OrgCode: btoa(JSON.stringify(OrgCode)), EntityID: btoa(JSON.stringify(EntityID)), pageName: btoa(JSON.stringify('Subscription')) }]);
  }

  public EditSubscriptionPage(TenantID: string, OrgCode: string, EntityID: string, entityCode: string, module: string) {
    localStorage.setItem('entityCode', entityCode);
    localStorage.setItem('module', module);
    localStorage.setItem('EntityID', EntityID);
    localStorage.setItem('OrganizationCode', OrgCode);
    this._router.navigate(['/SubscriptionDetails', {
      TenantID: btoa(JSON.stringify(TenantID)),
      EntityID: btoa(JSON.stringify(EntityID)),
      Module: btoa(JSON.stringify(module)),
      OrganizationCode: btoa(JSON.stringify(OrgCode)),
      EntityCode: btoa(JSON.stringify(entityCode)),
      pageName: btoa(JSON.stringify('Subscription'))
    }])
  }
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [month, day,year].join('/');
}



// WEBPACK FOOTER //
// ./src/app/Subscription/SubscriptionSearch.component.ts